/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


   document.addEventListener('DOMContentLoaded', function() {

// Flash Sale
     const flashSales = document.querySelectorAll('.flash_sale');

    flashSales.forEach(flashSaleDiv => {
      const startTime = new Date(flashSaleDiv.getAttribute('data-start'));
        const endTime = new Date(flashSaleDiv.getAttribute('data-end'));

        const updateTimer = () => {
            const currentTime = new Date();
            const timeToStart = startTime - currentTime;
            const timeToEnd = endTime - currentTime;
            const timeSinceEnd = currentTime - endTime;

            if (timeToStart > 0) {
                // Countdown before flash sale starts
                const days = Math.floor(timeToStart / (1000 * 60 * 60 * 24));
                const hours = Math.floor((timeToStart % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((timeToStart % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((timeToStart % (1000 * 60)) / 1000);

                flashSaleDiv.innerHTML = `<span>Flash sale starts in:</span><span> ${days.toString().padStart(2, '0')}:${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}</span>`;
            } else if (timeToEnd > 0) {
                // Countdown during flash sale
                const days = Math.floor(timeToEnd / (1000 * 60 * 60 * 24));
                const hours = Math.floor((timeToEnd % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((timeToEnd % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((timeToEnd % (1000 * 60)) / 1000);

                flashSaleDiv.innerHTML = `<span>Flash sale ends in:</span><span> ${days.toString().padStart(2, '0')}:${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}</span>`;
            } else if (timeSinceEnd <= 60 * 60 * 1000) {
                // Flash sale ended less than an hour ago
                flashSaleDiv.innerHTML = '<span>The flash sale has ended.</span>';
            } else {
                // Flash sale ended more than an hour ago, hide the element
                flashSaleDiv.style.display = 'none';
            }
        };

        // Call updateTimer immediately and then every second
        updateTimer(); 
        setInterval(updateTimer, 1000);
    });

// LAUNCH DATE

     
            function updateCountdown() {
                const products = document.querySelectorAll('.product-item');
                const singleProduct = document.querySelector('.index-product');

                function updateProductCountdown(product) {
                    const badge = product.querySelector('.launch-date-badge');
                    const buyButton = product.querySelector('.product__submit__buttons');
                    const quickBuyButton = product.querySelector('.quick-add__button');
                  
                    
                    if (badge) {
                        const launchTime = new Date(badge.getAttribute('data-time')).getTime();
                        const now = new Date().getTime();
                        const distance = launchTime - now;

                        console.log(`Distance: ${distance}`);

                        if (distance > 0) {
                            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                      if (days >= 1) {
                          badge.innerText = `Launching in ${days}D:${hours.toString().padStart(2, '0')}H:${minutes.toString().padStart(2, '0')}M`;
                      } else {
                          badge.innerText = `Launching in ${hours.toString().padStart(2, '0')}H:${minutes.toString().padStart(2, '0')}M:${seconds.toString().padStart(2, '0')}S`;
                      }

                      if (buyButton) {
                          buyButton.style.display = 'none';
                      }
                          
                          if (quickBuyButton) {
                          quickBuyButton.style.display = 'none';
                      }
                          
                        } else {
                            const daysPast = Math.floor(-distance / (1000 * 60 * 60 * 24));
                            if (daysPast <= 1) {
                                badge.innerText = "Just Launched";
                            } else {
                                badge.remove();
                            }
                            if (buyButton) {
                                buyButton.style.display = 'inline-block';
                            }
                            if (quickBuyButton) {
                                quickBuyButton.style.display = 'block';
                            }
                        }
                    }
                }

                products.forEach(product => updateProductCountdown(product));
                if (singleProduct) {
                    updateProductCountdown(singleProduct);
                }
            }

             function updateUpsellCountdown() {
              const upsellHolders = document.querySelectorAll('.product-upsell__holder');
        
              upsellHolders.forEach(holder => {
                const upcomingBadge = holder.querySelector('.upcoming-product');
                const upsellButton = holder.querySelector('.product-upsell__btn');
        
                if (upcomingBadge) {
                  const launchTime = new Date(upcomingBadge.getAttribute('data-time')).getTime();
                  const now = new Date().getTime();
                  const distance = launchTime - now;
        
                
        
                  if (distance > 0) {
                    if (upsellButton) {
                      upsellButton.style.display = 'none';
                    }
                  } else {
                    if (upsellButton) {
                      upsellButton.style.display = 'inline-block';
                    }
                  }
                }
              });
            }
        
            // Initial call to set the countdown and button visibility
            updateCountdown();
            updateUpsellCountdown();
        
            // Update countdown every second
            setInterval(updateCountdown, 1000);
            setInterval(updateUpsellCountdown, 1000);
             
        });




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
